import { SingleSkeletonLoader } from '../../../components/SingleSkeletonLoader';
import { IncludedHubSpotCredits } from '../../../components/merch-card/credits-display/IncludedHubSpotCredits';
import { useIncludedHubSpotCredits } from './useIncludedHubSpotCredits';
import { jsx as _jsx } from "react/jsx-runtime";
export const IncludedHubSpotCreditsContainer = ({
  productApiName,
  trackingSource = 'merch-card'
}) => {
  const {
    includedHubSpotCredits,
    loading: includedHubSpotCreditsLoading
  } = useIncludedHubSpotCredits({
    productApiName
  });
  if (includedHubSpotCreditsLoading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 17,
      width: "75%"
    });
  }
  return /*#__PURE__*/_jsx(IncludedHubSpotCredits, {
    includedProductLevelHubspotCredits: includedHubSpotCredits,
    trackingSource: trackingSource
  });
};